import { Component, OnInit, ViewChild } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApplicationType } from 'src/api/models/application-type';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { ApplicationService,CustomerService,CeresTagService } from 'src/api/services';


@Component({
  selector: 'app-ceres-tag-onboard',
  templateUrl: './onboard.component.html',
  styleUrls: ['./onboard.component.css']
})
export class CeresTagOnBoardComponent implements OnInit {

  public applications : ApplicationType[];
  state: string;
  redirect_uri: string;
  client_id: string;
  errorMessage: string;
  
  constructor(
    private route: ActivatedRoute,
    public azureAuthService: AzureAuthService,
    private app: ApplicationConfigService,
    private ceres: CeresTagService) { }

  ngOnInit(): void {    
    //alert('here');
    this.route.queryParams
      .subscribe(params => {
        // if not logged in - redirect to login page
        if (this.azureAuthService.isLoggedIn){
          this.state = params.state;
          this.redirect_uri = params.redirect_uri;
          this.client_id = params.rclient_id;
          console.log("Redirect URI ready = " + this.redirect_uri)
        } else {
          // set the current URL into the cookie
          //var returnto = window.location.href;
          //debugger;
          console.log("Storing Redirect_URI = " + window.location.hash.substring(1));
          document.cookie = "redirect_uri=" + window.location.hash.substring(1);
          //alert('here');
          this.azureAuthService.login();
        }
      }
    );
  }

 
  completeOnboarding(){
    this.ceres.CeresTagOnboard({state: this.state, clientId: this.client_id, customerId: this.app.customerId}).subscribe(s =>{

      var token = s.securityToken;

      window.location.assign(this.redirect_uri + "?state=" + this.state + "&access_token=" + token + "&expires_in=2147483640");

    }, error => {
        this.errorMessage = "It appears you do not have permission to link your Ceres Tag account to your INDICIUM Cloud account. Please contact the person in charge of your INDICIUM Dynamics account to be assigned the appropriate permissions."
    });
    
  }
}
